<template>
  <section>
    <SharedPageHeaderTitle :title="t('pages.contacts.headerTitle')" />

    <div class="base-container-first social__wrapper">
      <div class="social__item">
        {{ t("pages.contacts.email.label") }}

        <BaseLink
          class="social__item-link typography__title1"
          href="mailto:sayhi@donutapp.com"
        >
          sayhi@donutapp.com
        </BaseLink>
      </div>

      <div class="social__item">
        {{ t("pages.contacts.social.label") }}

        <ul class="item-social__list">
          <li>
            <BaseLink
              class="social-item__link"
              href="https://www.instagram.com/mydonutapp/"
              target="_blank"
            >
              <BaseIcon2
                id="icon-instagram-colored"
                class="social__image"
                height="24"
                sprite="socials"
                width="24"
              />
            </BaseLink>
          </li>

          <li>
            <BaseLink
              class="social-item__link"
              href="https://www.facebook.com/mydonutapp/"
              target="_blank"
            >
              <BaseIcon2
                id="icon-facebook-colored"
                class="social__image"
                height="24"
                sprite="socials"
                width="24"
              />
            </BaseLink>
          </li>

          <li>
            <BaseLink
              class="social-item__link"
              href="https://t.me/mydonutapp"
              target="_blank"
            >
              <BaseIcon2
                id="icon-telegram-colored"
                class="social__image"
                height="24"
                sprite="socials"
                width="24"
              />
            </BaseLink>
          </li>
        </ul>
      </div>
    </div>
  </section>

  <ContactOrderForm
    :description="t('pages.contacts.orderForm.description')"
    :title="t('pages.contacts.orderForm.title')"
  />
</template>

<script lang="ts" setup>
const { t } = useI18n();

useSeoMeta({
  title: t("pages.contacts.seo.title"),
});
</script>

<style scoped>
.social__wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
  width: 100%;
  margin: 0 auto 80px;
  padding: 0 24px;
}

@media (--desktop) {
  .social__wrapper {
    flex-direction: row;
    column-gap: 20px;
    margin-bottom: 120px;
  }
}

.social__item {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  width: 100%;
  color: var(--grey-2);
}

.item-social__list {
  display: flex;
  column-gap: 16px;
}

.social__item-link {
  justify-content: flex-start;
  color: var(--grey-1);
}

.social__image {
  object-fit: cover;
}
</style>
